import axiosInstance from '../axiosInterceptor/axiosInstance'

const getCompetition = async ({ orgId, competitionId }) => {
  const url = `v1/orgs/${orgId}/competitions/${competitionId}`
  const response = await axiosInstance.get(url)
  return response?.data
}

export default getCompetition
